import _ from 'lodash';
const applyPageI18NMessages = (vm, pageName, messages) => {
    const locales = Object.keys(messages);
    locales.forEach(locale => {
        if (_.hasIn(vm.$i18n.messages[locale], pageName))
            return;
        vm.$i18n.mergeLocaleMessage(locale, { [pageName]: messages[locale] });
    });
};
export default applyPageI18NMessages;
